// @flow

import type { BuildFormat } from '../types/flow/BuildFormat';

export default ([
  'amd',
  'cjs',
  'esm',
  'system',
]: BuildFormat[]);
